import { apiFetch } from "../utils/apiFetch";

/** Eine Zeile der Übersicht „Kontakte, die zu bereinigen sind". */
export interface DatenbereinigungRow {
  contactId: number;
  lastname: string | null;
  firstName: string | null;
  type: string | null;
  kundennummer: string | null;
  inAnsprechpartner: boolean;
  inHaushalt: boolean;
  inDuplikate: boolean;
  street: string | null;
  postalCode: string | null;
  city: string | null;
}

/** Paginierte Liste der zu bereinigenden Kontakte (Modul-Flags + Default-Adresse). */
export const listDatenbereinigung = async (
  q: string | undefined,
  limit: number,
  offset: number,
  signal?: AbortSignal,
): Promise<{ rows: DatenbereinigungRow[]; total: number }> => {
  const { data, total } = await apiFetch<DatenbereinigungRow[]>(
    "datenbereinigung/contacts",
    {
      params: {
        ...(q ? { q } : {}),
        limit,
        offset,
      },
      signal,
    },
  );
  return { rows: data ?? [], total: total ?? data?.length ?? 0 };
};

/** Ein Mitglied/Ansprechpartner im aufklappbaren Treffer-Detail. */
export interface DatenbereinigungMember {
  contactId: number | null;
  candidateId?: number;
  lastname: string | null;
  firstName: string | null;
  kundennummer?: string | null;
  householdRole?: string | null;
  relationType?: string | null;
  function?: string | null;
  bereinigtAt?: string | null;
}

/** Aufklapp-Detail eines Treffers: Person → Haushalt-Kandidaten, Firma → Ansprechpartner. */
export interface DatenbereinigungRelated {
  kind: "household" | "ansprechpartner" | "none";
  members: DatenbereinigungMember[];
}

export const fetchDatenbereinigungRelated = async (
  contactId: number,
  signal?: AbortSignal,
): Promise<DatenbereinigungRelated> => {
  const { data } = await apiFetch<DatenbereinigungRelated>(
    `datenbereinigung/contacts/${contactId}/related`,
    { signal },
  );
  return data ?? { kind: "none", members: [] };
};
